import { gql } from '@apollo/client';
import { Vertical, VERTICALS } from '@moda/portal-stanchions';
import React from 'react';
import { ItemList, ListItem } from 'schema-dts';
import { SchemaOrgProductListingFragment } from '../../generated/types/SchemaOrgProductListingFragment';
import { hrefFor } from '../../routers';

export const SCHEMA_ORG_PRODUCT_LISTING_FRAGMENT = gql`
  fragment SchemaOrgProductListingFragment on Variant {
    id
    gender
    designerSlug: designer_slug
    productSlug: slug
  }
`;

type Props = {
  variants: SchemaOrgProductListingFragment[];
};

export const SchemaOrgProductListing: React.FC<Props> = ({ variants }) => {
  const itemListElement: ListItem[] = variants.map((variant, index) => {
    const href = hrefFor.ProductDetailPage({
      vertical: VERTICALS[variant.gender as Vertical],
      designerSlug: variant.designerSlug || '',
      productSlug: variant.productSlug,
      variantId: variant.id
    });
    return {
      '@type': 'ListItem',
      position: index + 1,
      url: `https://www.modaoperandi.com${href}`
    };
  });

  const schema: ItemList = {
    '@type': 'ItemList',
    itemListElement
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};
